
<template>
    <div class="agreement-container">
        <div class="terms">
            <label @click.prevent="toggleCheck" :class="{notAccepted : msgAfterValid }" class="checkbox-label">
                <input type="checkbox" v-model="isChecked">
                <span class="checkmark"/>
            </label>
            <router-link to="/statute"><p>{{translate('regulations')}}</p></router-link>
        </div>
    </div>
</template>
<script>

    export default {
        name: "Terms",
        props: ['name', 'required'],
        data() {
            return {
                isChecked: false,
                msgAfterValid: false
            }
        },
        methods: {
            toggleCheck(e){
                this.isChecked = !this.isChecked;
                this.updateMsgAfterValid();
            },

            updateMsgAfterValid() {

                this.msgAfterValid = !this.isChecked;

                this.$parent.$emit('validateData', {

                    inputName: this.name,
                    isIncorrect: !this.isChecked,
                    value: this.isChecked ? this.isChecked : !this.isChecked
                });
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
        },

        mounted(){
            this.$parent.$on('getValidateData', () => {
                this.updateMsgAfterValid();
            });
        }
    }
</script>